import AppShell from './AppShell';
import { isComponentFor } from 'Shared/resolve-component';
export default (currentPage) => {
    return isComponentFor(currentPage.componentName, AppShell.name);
};
